import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import apiClient from '../utils/api';
import { toast } from 'sonner';

export const FacebookCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState('Processing Facebook login...');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');
        const errorDescription = searchParams.get('error_description');

        if (error) {
          console.error('Facebook OAuth error:', error, errorDescription);
          toast.error(errorDescription || 'Facebook login was cancelled');
          navigate('/login');
          return;
        }

        if (!code) {
          console.error('No authorization code found');
          toast.error('Facebook login failed - no authorization code');
          navigate('/login');
          return;
        }

        setStatus('Verifying with Facebook...');

        // Exchange the code for user data via backend
        const response = await apiClient.get(`/auth/facebook/callback?code=${code}&state=${state || ''}`, {
          withCredentials: true
        });

        const { token, user } = response.data;

        if (token && user) {
          // Store token in localStorage (same as regular login)
          localStorage.setItem('token', token);
          
          toast.success(`Welcome, ${user.name}!`);
          navigate('/dashboard', { state: { user }, replace: true });
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Facebook callback error:', error);
        const errorMessage = error.response?.data?.detail || 'Facebook login failed';
        toast.error(errorMessage);
        navigate('/login');
      }
    };

    processCallback();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">{status}</p>
      </div>
    </div>
  );
};
